/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ImplantProperty from './implant-property';
import ImplantPropertyDetail from './implant-property-detail';
import ImplantPropertyUpdate from './implant-property-update';
import ImplantPropertyDeleteDialog from './implant-property-delete-dialog';

const ImplantPropertyRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ImplantProperty />} />
    <Route path="new" element={<ImplantPropertyUpdate />} />
    <Route path=":id">
      <Route index element={<ImplantPropertyDetail />} />
      <Route path="edit" element={<ImplantPropertyUpdate />} />
      <Route path="delete" element={<ImplantPropertyDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ImplantPropertyRoutes;
